import { Box } from '@givebutter/primitives/box';

const PledgesMetricsItem = ({ children }: { children: React.ReactNode }) => {
    return <Box className="flex gap-4 p-4">{children}</Box>;
};

const PledgesMetricsIcon = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="flex size-12 items-center justify-center rounded-lg border border-gray-200 text-purple-500">
            {children}
        </div>
    );
};

const PledgesMetricsTitle = ({ children }: { children: React.ReactNode }) => {
    return <div className="text-sm font-medium text-gray-600">{children}</div>;
};

const PledgesMetricsValue = ({ children }: { children: React.ReactNode }) => {
    return <div className="text-2xl font-medium text-gray-900">{children}</div>;
};

const PledgesMetricsContent = ({ children }: { children: React.ReactNode }) => {
    return <div className="flex flex-col">{children}</div>;
};

const Root = PledgesMetricsItem;
const Icon = PledgesMetricsIcon;
const Title = PledgesMetricsTitle;
const Content = PledgesMetricsContent;
const Value = PledgesMetricsValue;

export {
    PledgesMetricsItem,
    PledgesMetricsIcon,
    PledgesMetricsTitle,
    PledgesMetricsValue,
    //
    Root,
    Icon,
    Title,
    Content,
    Value,
};
